import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    LegalNoticeDetailComponent,
    legalNoticeRoute
} from './';

let ENTITY_STATES = [
    ...legalNoticeRoute
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        LegalNoticeDetailComponent
    ],
    entryComponents: [
    ],
    providers: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiLegalNoticeModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/legal-notice/legal-notice.module.ts